import type { FC } from 'react';

import LegalDocument from '@/features/legal/components/LegalDocument';
import { useSupportPage } from '@/features/legal/hooks/useSupportPage.hook';

const SupportPage: FC = () => {
  const { content, lastUpdated } = useSupportPage();

  return <LegalDocument content={content} lastUpdated={lastUpdated} eyebrow="Support" />;
};

export default SupportPage;
